import useParticipantBillView from '@/features/dashboard/bookingChanges/hooks/useParticipantBillView.ts';
import {
  ParticipantBillView,
  ParticipantBillViewSkeleton,
} from '@/features/dashboard/bookingChanges/components/bill';
import { AddManualLineParams } from '@/features/dashboard/bookingChanges/types/ChangeViewModel.ts';
import EmbeddedBillEmpty from './EmbeddedBillEmpty';
import { EmbeddedBillProps, embeddedSkeletonClass } from './embeddedBill';

interface EmbeddedParticipantBillProps extends EmbeddedBillProps {
  participantId: string;
  onlyChanged: boolean;
  onOnlyChangedChange: (onlyChanged: boolean) => void;
  /** „+ Wolna linia” w sekcji osoby — właściciela dopina sam widok. */
  onAddManualRow: (params: AddManualLineParams) => void;
}

/**
 * Treść rozwiniętego kafla uczestnika — dokładnie ten sam komponent, co ekran
 * uczestnika. Widok siedzi w osobnym komponencie, bo każdy kafel potrzebuje
 * własnego wywołania hooka; zapytania i tak dzielą jeden wpis w cache.
 */
const EmbeddedParticipantBill = ({
  bookingId,
  bookingCode,
  isEditing,
  onOpenBooking,
  onRowAction,
  onAddManualRow,
  participantId,
  onlyChanged,
  onOnlyChangedChange,
  ...props
}: EmbeddedParticipantBillProps) => {
  const { view, isLoading } = useParticipantBillView(bookingId, participantId);

  if (isLoading) {
    return (
      <ParticipantBillViewSkeleton
        className={embeddedSkeletonClass}
        {...props}
      />
    );
  }

  if (!view) {
    return (
      <EmbeddedBillEmpty
        title="Brak rachunku uczestnika"
        description="Ten uczestnik nie ma jeszcze pozycji w rachunku tej rezerwacji."
        {...props}
      />
    );
  }

  return (
    <ParticipantBillView
      embedded
      data={view}
      isEditing={isEditing}
      onlyChanged={onlyChanged}
      onOnlyChangedChange={onOnlyChangedChange}
      onRowAction={onRowAction}
      onAddManualRow={onAddManualRow}
      onOpenInstallments={onOpenBooking}
      bookingCode={bookingCode}
      showShare={false}
      {...props}
    />
  );
};

export default EmbeddedParticipantBill;
